import React from 'react';
import classnames from "classnames";
import { Input } from 'antd';
import 'antd/lib/input/style/index.css';
import 'antd/lib/button/style/index.css';
import './Search.scss';

const { Search: SearchInput } = Input;

export function Search({ className, ...props }) {
  return (
    <SearchInput
      allowClear
      placeholder="Search"
      className={classnames('Search', className)}
      {...props}
    />
  );
}
